var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EXPLORE_BOOKMARK_SCHEMES, EXPLORE_BOOKMARK_SCHEMES_BONDS, EXPLORE_BOOKMARK_SCHEMES_NCD, EXPLORE_BOOKMARK_SCHEMES_SP, EXPLORE_BOOKMARK_SCHEMES_UNLISTED_SHARES, EXPLORE_CASH_FLOW, EXPLORE_DOWNLOAD_DATA, EXPLORE_DRAFT_COUNT, EXPLORE_DRAFT_ORDERS, EXPLORE_PRODUCT_AVAILABLE_QUANTITY, EXPLORE_PRODUCT_COUPON_FILTERS, EXPLORE_PRODUCT_DETAILS, EXPLORE_PRODUCT_INTERESTFREQUENCY_FILTERS, EXPLORE_PRODUCT_ISSUERNAME_FILTERS, EXPLORE_PRODUCT_LOCAL_AVAILABLE_QUANTITY, EXPLORE_PRODUCT_LOCAL_CLIENT_NAME, EXPLORE_PRODUCT_LOCAL_COUPON_FILTERS, EXPLORE_PRODUCT_LOCAL_INTERESTFREQUENCY_FILTERS, EXPLORE_PRODUCT_LOCAL_INVESTMENT_VALUE, EXPLORE_PRODUCT_LOCAL_ISSUERNAME_FILTERS, EXPLORE_PRODUCT_LOCAL_MATURITYDATE_FILTERS, EXPLORE_PRODUCT_LOCAL_MIN_INVESTMENT, EXPLORE_PRODUCT_LOCAL_PRICERANGE_FILTERS, EXPLORE_PRODUCT_LOCAL_PRODUCT_TYPE, EXPLORE_PRODUCT_LOCAL_RATING_FILTERS, EXPLORE_PRODUCT_LOCAL_STATUS, EXPLORE_PRODUCT_LOCAL_TYPE_FILTERS, EXPLORE_PRODUCT_MATURITYDATE_FILTERS, EXPLORE_PRODUCT_MIN_INVESTMENT, EXPLORE_PRODUCT_PRICERANGE_FILTERS, EXPLORE_PRODUCT_RATING_FILTERS, EXPLORE_PRODUCT_TABS, EXPLORE_PRODUCT_TYPE_FILTERS, EXPLORE_USER_POPUP_STATUS, EXPLORE_USER_POPUP_STATUS_SAVE, EXPLORE_WATCHLIST_SCHEMES, MULTI_UPDATE_BOOKMARK, RESET_VALUE_FILTER, UPDATE_BONDS_REQUEST_PAYLOAD_ID, UPDATE_BOOKMARK, UPDATE_NCD_REQUEST_PAYLOAD_ID, UPDATE_ONBOARD_POPUP, UPDATE_SP_REQUEST_PAYLOAD_ID, UPDATE_SUB_CATEGORY_ID, UPDATE_UNLISTED_REQUEST_PAYLOAD_ID, UPDATE_WATCHLIST_REQUEST_PAYLOAD_ID, USER_UNAUTHORIZED, } from "../interface/iProductBouquet";
var initState = {
    watchListSchemes: null,
    productDetails: null,
    cashFlow: null,
    subCategoryId: "",
    watchListRequestPayload: null,
    productTabs: null,
    bookMarkListSp: null,
    bookMarkListNcd: null,
    bookMarkListBonds: null,
    bookMarkListUnlistedShares: null,
    bookMark: null,
    userPopupStatus: null,
    userPopupStatusSave: null,
    isOnBoardPopup: false,
    draftOrders: null,
    draftOrderCount: null,
    productRatingFilters: null,
    productInterestFrequencyFilters: null,
    productIssuerNameFilters: null,
    productMaturityDateFilters: null,
    productTypeFilters: null,
    productCouponFilters: null,
    productPriceRangeFilters: null,
    productLocalRatingFilters: null,
    productLocalInterestFrequencyFilters: null,
    productLocalIssuerNameFilters: null,
    productLocalMaturityDateFilters: null,
    productLocalTypeFilters: null,
    productLocalCouponFilters: null,
    productLocalPriceRangeFilters: null,
    productLocalMinInvestmentFilters: null,
    productLocalAvailableQuantityFilters: null,
    productAvailableQuantityFilters: null,
    productMinInvestmentFilters: null,
    bookMarkList: null,
    downloadData: null,
    productLocalProductTypeFilters: null,
    productLocalStatusFilters: null,
    productLocalClientNameFilters: null,
    productLocalInvestmentValueFilters: null,
    userUnauthorized: null,
};
var productBouquetReducer = function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case EXPLORE_WATCHLIST_SCHEMES:
            return __assign(__assign({}, state), { watchListSchemes: action.payload.watchListSchemes });
        case USER_UNAUTHORIZED:
            return __assign(__assign({}, state), { userUnauthorized: action.payload.userUnauthorized });
        case EXPLORE_BOOKMARK_SCHEMES:
            return __assign(__assign({}, state), { bookMarkList: action.payload.bookMarkList });
        case EXPLORE_BOOKMARK_SCHEMES_SP:
            return __assign(__assign({}, state), { bookMarkListSp: action.payload.bookMarkListSp });
        case EXPLORE_BOOKMARK_SCHEMES_NCD:
            return __assign(__assign({}, state), { bookMarkListNcd: action.payload.bookMarkListNcd });
        case EXPLORE_BOOKMARK_SCHEMES_BONDS:
            return __assign(__assign({}, state), { bookMarkListBonds: action.payload.bookMarkListBonds });
        case EXPLORE_BOOKMARK_SCHEMES_UNLISTED_SHARES:
            return __assign(__assign({}, state), { bookMarkListUnlistedShares: action.payload.bookMarkListUnlistedShares });
        case EXPLORE_PRODUCT_TABS:
            return __assign(__assign({}, state), { productTabs: action.payload.productTabs });
        case EXPLORE_PRODUCT_DETAILS:
            return __assign(__assign({}, state), { productDetails: action.payload.productDetails });
        case EXPLORE_PRODUCT_RATING_FILTERS:
            return __assign(__assign({}, state), { productRatingFilters: action.payload.productRatingFilters });
        case EXPLORE_PRODUCT_INTERESTFREQUENCY_FILTERS:
            return __assign(__assign({}, state), { productInterestFrequencyFilters: action.payload.productInterestFrequencyFilters });
        case EXPLORE_PRODUCT_ISSUERNAME_FILTERS:
            return __assign(__assign({}, state), { productIssuerNameFilters: action.payload.productIssuerNameFilters });
        case EXPLORE_PRODUCT_MATURITYDATE_FILTERS:
            return __assign(__assign({}, state), { productMaturityDateFilters: action.payload.productMaturityDateFilters });
        case EXPLORE_PRODUCT_PRICERANGE_FILTERS:
            return __assign(__assign({}, state), { productPriceRangeFilters: action.payload.productPriceRangeFilters });
        case EXPLORE_PRODUCT_TYPE_FILTERS:
            return __assign(__assign({}, state), { productTypeFilters: action.payload.productTypeFilters });
        case EXPLORE_PRODUCT_COUPON_FILTERS:
            return __assign(__assign({}, state), { productCouponFilters: action.payload.productCouponFilters });
        case EXPLORE_CASH_FLOW:
            return __assign(__assign({}, state), { cashFlow: action.payload.cashFlow });
        case UPDATE_SUB_CATEGORY_ID:
            return __assign(__assign({}, state), { subCategoryId: action.payload.subCategoryId });
        case UPDATE_BOOKMARK:
            return __assign(__assign({}, state), { bookMark: action.payload.bookMark });
        case MULTI_UPDATE_BOOKMARK:
            return __assign(__assign({}, state), { bookMark: action.payload.bookMark });
        case EXPLORE_DOWNLOAD_DATA:
            return __assign(__assign({}, state), { downloadData: action.payload.downloadData });
        case UPDATE_WATCHLIST_REQUEST_PAYLOAD_ID:
            return __assign(__assign({}, state), { watchListRequestPayload: action.payload.watchListRequestPayload });
        case UPDATE_UNLISTED_REQUEST_PAYLOAD_ID:
            return __assign(__assign({}, state), { watchListUnlistedRequestPayload: action.payload.watchListUnlistedRequestPayload });
        case UPDATE_NCD_REQUEST_PAYLOAD_ID:
            return __assign(__assign({}, state), { watchListNcdRequestPayload: action.payload.watchListNcdRequestPayload });
        case UPDATE_BONDS_REQUEST_PAYLOAD_ID:
            return __assign(__assign({}, state), { watchListBondsRequestPayload: action.payload.watchListBondsRequestPayload });
        case UPDATE_SP_REQUEST_PAYLOAD_ID:
            return __assign(__assign({}, state), { watchListSpRequestPayload: action.payload.watchListSpRequestPayload });
        case EXPLORE_USER_POPUP_STATUS_SAVE:
            return __assign(__assign({}, state), { userPopupStatusSave: action.payload.userPopupStatusSave });
        case EXPLORE_USER_POPUP_STATUS:
            return __assign(__assign({}, state), { userPopupStatus: action.payload.userPopupStatus });
        case UPDATE_ONBOARD_POPUP:
            return __assign(__assign({}, state), { isOnBoardPopup: action.payload.isOnBoardPopup });
        case UPDATE_ONBOARD_POPUP:
            return __assign(__assign({}, state), { isOnBoardPopup: action.payload.isOnBoardPopup });
        case EXPLORE_DRAFT_ORDERS:
            return __assign(__assign({}, state), { draftOrders: action.payload.draftOrders });
        case EXPLORE_DRAFT_COUNT:
            return __assign(__assign({}, state), { draftOrderCount: action.payload.draftOrderCount });
        case EXPLORE_PRODUCT_LOCAL_RATING_FILTERS:
            return __assign(__assign({}, state), { productLocalRatingFilters: action.payload.productLocalRatingFilters });
        case EXPLORE_PRODUCT_LOCAL_INTERESTFREQUENCY_FILTERS:
            return __assign(__assign({}, state), { productLocalInterestFrequencyFilters: action.payload.productLocalInterestFrequencyFilters });
        case EXPLORE_PRODUCT_LOCAL_ISSUERNAME_FILTERS:
            return __assign(__assign({}, state), { productLocalIssuerNameFilters: action.payload.productLocalIssuerNameFilters });
        case EXPLORE_PRODUCT_LOCAL_MATURITYDATE_FILTERS:
            return __assign(__assign({}, state), { productLocalMaturityDateFilters: action.payload.productLocalMaturityDateFilters });
        case EXPLORE_PRODUCT_LOCAL_PRICERANGE_FILTERS:
            return __assign(__assign({}, state), { productLocalPriceRangeFilters: action.payload.productLocalPriceRangeFilters });
        case EXPLORE_PRODUCT_LOCAL_TYPE_FILTERS:
            return __assign(__assign({}, state), { productLocalTypeFilters: action.payload.productLocalTypeFilters });
        case EXPLORE_PRODUCT_LOCAL_COUPON_FILTERS:
            return __assign(__assign({}, state), { productLocalCouponFilters: action.payload.productLocalCouponFilters });
        case EXPLORE_PRODUCT_LOCAL_AVAILABLE_QUANTITY:
            return __assign(__assign({}, state), { productLocalAvailableQuantityFilters: action.payload.productLocalAvailableQuantityFilters });
        case EXPLORE_PRODUCT_LOCAL_MIN_INVESTMENT:
            return __assign(__assign({}, state), { productLocalMinInvestmentFilters: action.payload.productLocalMinInvestmentFilters });
        case EXPLORE_PRODUCT_LOCAL_PRODUCT_TYPE:
            return __assign(__assign({}, state), { productLocalProductTypeFilters: action.payload.productLocalProductTypeFilters });
        case EXPLORE_PRODUCT_LOCAL_STATUS:
            return __assign(__assign({}, state), { productLocalStatusFilters: action.payload.productLocalStatusFilters });
        case EXPLORE_PRODUCT_LOCAL_CLIENT_NAME:
            return __assign(__assign({}, state), { productLocalClientNameFilters: action.payload.productLocalClientNameFilters });
        case EXPLORE_PRODUCT_LOCAL_INVESTMENT_VALUE:
            return __assign(__assign({}, state), { productLocalInvestmentValueFilters: action.payload.productLocalInvestmentValueFilters });
        case EXPLORE_PRODUCT_AVAILABLE_QUANTITY:
            return __assign(__assign({}, state), { productAvailableQuantityFilters: action.payload.productAvailableQuantityFilters });
        case EXPLORE_PRODUCT_MIN_INVESTMENT:
            return __assign(__assign({}, state), { productMinInvestmentFilters: action.payload.productMinInvestmentFilters });
        case RESET_VALUE_FILTER:
            return __assign(__assign({}, state), { productLocalRatingFilters: null, productLocalInterestFrequencyFilters: null, productLocalIssuerNameFilters: null, productLocalMaturityDateFilters: null, productLocalTypeFilters: null, productLocalCouponFilters: null, productLocalPriceRangeFilters: null, productLocalMinInvestmentFilters: null, productLocalAvailableQuantityFilters: null, draftOrderCount: null, draftOrders: null, productLocalProductTypeFilters: null, productLocalStatusFilters: null, productLocalClientNameFilters: null, productLocalInvestmentValueFilters: null });
        default:
            return __assign({}, state);
    }
};
export default productBouquetReducer;
